<template>
  <div class="goal-preview-stats">
    <div class="cover">
      <img :src="goal_image_url" alt="">
    </div>
    <ProgressWaves class="mb-8"
                   :width="summary.progress"
                   :color="summary.progress ? summary.color : 'default'"
                   size="small"/>
    <GoalProgressTip v-if="status !== 2"
                     :goal_type="goal_type"
                     :account_title="account_title"
                     :summary="summary"/>
    <div v-if="description" class="mb-4 border border-line rounded p-6 text-2sm text-text-ternary flex items-start">
      <IconChatIconly class="mr-6 flex-none"/>
      <span class="whitespace-pre-wrap break-all">{{ description }}</span>
    </div>
  </div>
</template>

<script>
import ProgressWaves from "@/components/common/ProgressWaves";
import IconImage from "@/components/icons/IconImage";
import IconComment from "@/components/icons/IconComment";
import IconChatIconly from "@/components/icons/IconChatIconly";
import IconFaceConfusion from "@/components/icons/IconFaceConfusion";
import IconFaceHappy from "@/components/icons/IconFaceHappy";
import IconFaceSad from "@/components/icons/IconFaceSad";
import GoalProgressTip from "@/components/cabinet/Money/Goals/GoalPreview/GoalProgressTip";

export default {
  name: "GoalPreviewInfo",
  components: {
    GoalProgressTip,
    IconFaceSad, IconFaceHappy, IconFaceConfusion, IconChatIconly, IconComment, IconImage, ProgressWaves
  },
  props: {
    goal_type: {
      type: Number
    },
    account_title: {
      type: String
    },
    goal_image_url: {
      type: String
    },
    description: {
      type: String
    },
    summary: {
      type: Object
    },
    status: {
      type: Number
    },
  },
}
</script>

<style lang="scss" scoped>
.goal-preview-stats {
  .cover {
    @apply rounded mb-4 overflow-hidden;
    width: 350px;
    height: 180px;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
</style>